import { gql } from '@apollo/client'

export const TRANSACTIONS_QUERY = gql`
  query Transactions($filters: TransactionFilterInput!, $sortBy: SortBy!) {
    transactions(filters: $filters, sortBy: $sortBy) {
      transactions {
        transactionID
        walletID
        type
        status
        amount
        time
        description
        relatedTransactionIDs
        userID
        createdAt
        updatedAt
        creditorID
        correlationID
        serviceID
        requestTime
        paymentStatus
        dueDate
        paymentTermID
        proformaID
        usedBalanceType
        fundingMode
        sumOfPenalty
        rewardOfEarlyPayment
        reservationNumber
        entity {
          entityType
          entityID
          entityCode
          displayEntityCode
          entityName
        }
        creditorEntity {
          entityType
          entityID
          entityCode
          displayEntityCode
          entityName
        }
        currency
      }
      total
    }
  }
`

export const SETTLEMENT_TRANSACTIONS_QUERY = gql`
  query SettlementTransactions(
    $filters: PaymentTransactionFilterInput!
    $sortBy: SortBy
  ) {
    settlementTransactions(filters: $filters, sortBy: $sortBy) {
      transactions {
        transactionID
        walletID
        type
        status
        amount
        time
        description
        relatedTransactionIDs
        userID
        createdAt
        updatedAt
        creditorID
        correlationID
        serviceID
        requestTime
        paymentStatus
        dueDate
        paymentTermID
        proformaID
        usedBalanceType
        sumOfPenalty
        rewardOfEarlyPayment
        reservationNumber
        entity {
          entityType
          entityID
          entityCode
          displayEntityCode
          entityName
        }
        creditorEntity {
          entityType
          entityID
          entityCode
          displayEntityCode
          entityName
        }
        currency
      }
      total
    }
  }
`

export const TRANSACTION_HISTORY_QUERY = gql`
  query TransactionHistory($transactionID: ID!) {
    transactionHistory(transactionID: $transactionID) {
      historyID
      transactionID
      status
      paymentStatus
      changedBy
      createdAt
    }
  }
`

export const CALCULATE_ALL_TRANSACTIONS_JOB_WITHOUT_UPCOMING_SUB = gql`
  subscription CalculateAllTransactionsWithoutUpcomingJobHandler(
    $trackingID: ID!
  ) {
    calculateAllTransactionsWithoutUpcomingJobHandler(trackingID: $trackingID) {
      status
      totalAmount
      transactionIDs
    }
  }
`

export const ALL_SETTLEMENT_TRANSACTIONS_WITHOUT_UPCOMING = gql`
  query AllSettlementTransactionsWithoutUpcoming(
    $filters: AllPaymentTransactionFilterInput!
  ) {
    allSettlementTransactionsWithoutUpcoming(filters: $filters) {
      trackingID
    }
  }
`
export const CALCULATE_ALL_TRANSACTIONS_JOB_SUB = gql`
  subscription CalculateAllTransactionsJobHandler($trackingID: String!) {
    calculateAllTransactionsJobHandler(trackingID: $trackingID) {
      status
      totalAmount
      transactionIDs
    }
  }
`

export const ALL_SETTLEMENT_TRANSACTIONS = gql`
  query AllSettlementTransactions($filters: AllPaymentTransactionFilterInput!) {
    allSettlementTransactions(filters: $filters) {
      trackingID
    }
  }
`

export const MAKE_TRANSACTION_IN_WALLET_MUTATION = gql`
  mutation MakeTransactionInWallet($input: TransactionInput!) {
    makeTransactionInWallet(input: $input) {
      message
    }
  }
`
